import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type DiscountFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const DiscountFilled = forwardRef<SVGSVGElement, DiscountFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(1.174392 0.500002) scale(0.902134)">
        <path d="M15.4287 0C17.7953 0.000242663 19.7136 1.91858 19.7139 4.28516C19.7139 5.15437 19.4545 5.96239 19.0098 6.6377H20.5713C22.4648 6.6377 23.9999 8.17292 24 10.0664V22.0664L23.9814 22.416C23.8178 24.0301 22.535 25.3129 20.9209 25.4766L20.5713 25.4951H3.42871L3.0791 25.4766C1.46502 25.3129 0.182195 24.0301 0.0185547 22.416L0 22.0664V10.0664C7.55665e-05 8.17292 1.53521 6.6377 3.42871 6.6377H5.08496C4.64035 5.96244 4.38086 5.15426 4.38086 4.28516C4.3811 1.91867 6.29957 0.000393371 8.66602 0C10.0402 0 11.2625 0.647654 12.0469 1.65332C12.8312 0.647369 14.0544 0.000142324 15.4287 0ZM2.22852 22.0664C2.22859 22.7291 2.76602 23.2666 3.42871 23.2666H20.5713C21.234 23.2666 21.7714 22.7291 21.7715 22.0664V20.3516H2.22852V22.0664ZM3.42871 8.86621C2.76602 8.86621 2.22859 9.40373 2.22852 10.0664V16.9238H21.7715V10.0664C21.7714 9.40373 21.234 8.86621 20.5713 8.86621H16.1162L17.9648 11.6406C18.3731 12.253 18.2087 13.0806 17.5967 13.4893C16.9843 13.8971 16.1566 13.7329 15.748 13.1211L12.9111 8.86621H11.1826L8.34668 13.1211C7.938 13.7329 7.11038 13.8973 6.49805 13.4893C5.88625 13.0806 5.72176 12.253 6.12988 11.6406L7.97852 8.86621H3.42871ZM8.66602 2.22852C7.53037 2.22891 6.60962 3.14948 6.60938 4.28516C6.60938 5.42104 7.53022 6.34238 8.66602 6.34277C9.1676 6.34277 9.62732 6.16262 9.98438 5.86426C10.0609 5.76259 10.1496 5.67484 10.2471 5.60156C10.5445 5.24478 10.7236 4.78583 10.7236 4.28516C10.7234 3.14923 9.80199 2.22852 8.66602 2.22852ZM15.4287 2.22852C14.2929 2.22876 13.3713 3.14939 13.3711 4.28516C13.3711 4.78573 13.5504 5.24481 13.8477 5.60156C13.9452 5.67482 14.0338 5.76262 14.1104 5.86426C14.4673 6.16261 14.9272 6.34266 15.4287 6.34277C16.5646 6.34253 17.4854 5.42113 17.4854 4.28516C17.4851 3.14938 16.5645 2.22876 15.4287 2.22852Z" />
      </g>
    </svg>
  ),
);

DiscountFilled.displayName = 'DiscountFilled';

export default DiscountFilled;
